import React from 'react';
import { IconProps } from './types';

const CheckMarkIcon = ({ className }: IconProps): React.ReactElement => (
  <svg
    height="24"
    width="24"
    viewBox="-4 -4 24 24"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 7.94l2.5 2.5 6-6 1.06 1.06-7.06 7.06L2.94 9 4 7.94z"
    />
  </svg>
);

export default CheckMarkIcon;
